import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["GalleryCarousel"] */ "/home/runner/work/web/web/src/app/(frontend)/[locale]/arbimary/GalleryCarousel.tsx");
